import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomCenter = styled(Center)`
    & .carousel-root {
        width: 100%;
    }

    & .carousel .control-dots {
        & .dot {
            width: 16px;
            height: 16px;
            box-shadow: none;
        }
    }
`;

export const CustomButton = styled(Button)`
    width: auto;
    ${FONT("pretendard", 16, 300)}
    padding:0 36px;
    border: 1px solid #6b6b6b;
    border-radius: 0;
    color: ${({ theme }) => theme.COLOR.black};
    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        font-size: 14px !important;
    }
`;
